import { SidebarItem, SidebarItemType } from '@siemens/component-lib';

export const sidebarItems: SidebarItem[] = [
    {
        routerLink: '/home',
        tooltip: 'sidebar.home',
        icon: 'home',
        name: 'sidebar.home',
        type: SidebarItemType.LINK,
        ariaLabel: 'sidebar.home'
    },
    {
        routerLink: '/manual',
        tooltip: 'sidebar.manual',
        icon: 'document-information',
        name: 'sidebar.manual',
        type: SidebarItemType.LINK,
        ariaLabel: 'sidebar.manual'
    },
    {
        routerLink: '/user-information',
        tooltip: 'sidebar.user-information',
        icon: 'circle-information',
        name: 'sidebar.user-information',
        type: SidebarItemType.LINK,
        ariaLabel: 'sidebar.user-information'
    }
];

export const bottomSidebarItems: SidebarItem[] = [
    {
        routerLink: 'https://siemensgbs.service-now.com/esc?id=sc_cat_item&sys_id=1a813c57c347621050eff7bc7a013188',
        tooltip: 'sidebar.support',
        icon: 'help',
        name: 'sidebar.support',
        type: SidebarItemType.LINK,
        ariaLabel: 'sidebar.support'
    }
];

export const unauthorizedSidebarItems: SidebarItem[] = [
    {
        routerLink: '/home',
        tooltip: 'sidebar.home',
        icon: 'home',
        name: 'sidebar.home',
        type: SidebarItemType.LINK,
        ariaLabel: 'sidebar.home'
    },
    {
        routerLink: '/manual',
        tooltip: 'sidebar.manual',
        icon: 'document-information',
        name: 'sidebar.manual',
        type: SidebarItemType.LINK,
        ariaLabel: 'sidebar.manual'
    },
    {
        routerLink: '/user-information',
        tooltip: 'sidebar.user-information',
        icon: 'circle-information',
        name: 'sidebar.user-information',
        type: SidebarItemType.LINK,
        ariaLabel: 'sidebar.user-information'
    }
];
